module.exports = __webpack_public_path__ + "img/examinInfo1.3b03b835.png";